import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BaseComponent,
  SelectOption,
  States,
  hideString,
} from 'src/app/shared';
import { SearchResult } from 'src/app/shared/models/search-result';
import { Http } from 'src/app/shared/services/http.service';
import { UserPreference } from '../../models/UserPreference';
import { AccountSettingsService } from '../../services/accountsettings.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Session } from '../../services/session.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { TranslationPipe } from '../../pipes/translation.pipe';
@Component({
    selector: 'app-contact-preferences',
    template: `
    <app-panel
      title="Your contact information"
      fxFlex="100"
      [headerLevel]="2"
      titleCollapse="Collapse contact information"
      titleExpand="Expand contact information"
      >
      <div fxLayout="row wrap">
        @if (
          this.claimConfigService.getFeatureAccess('updatecontactaddress')
          ) {
          <div
            >
            <app-value fxFlex="50" label="CONTACT ADDRESS" [valueTemplate]="addressTpl">
              <ng-template #addressTpl>
                <span
                [innerHTML]="
                  {
                    street1:
                      contactInformation?.street1 !== undefined
                        ? (contactInformation?.street1 | titlecase)
                        : '',
                    street2:
                      contactInformation?.street2 !== undefined
                        ? (contactInformation?.street2 | titlecase)
                        : '',
                    city:
                      contactInformation?.city !== undefined
                        ? (contactInformation?.city | titlecase)
                        : '',
                    state: stateVal !== undefined ? stateVal : '',
                    zipCode:
                      contactInformation?.zipcode !== undefined
                        ? contactInformation?.zipcode
                        : ''
                  } | address
                "
                  >
                </span>
              </ng-template>
            </app-value>
            <app-action-link
              class="app-pb1"
              title="Change contact address"
              tabindex="-1"
            (click)="
              FeatureLogging(
                'ChangeContactAddress',
                'Change Contact Address',
                'Summary - Your contact information'
              )
            "
              routerLink="/yourcontactinformation"
            [queryParams]="{
              claimId: claimId,
              source: source
            }"
            ></app-action-link>
          </div>
        }
        <br />
        @if (showNotificationPreference) {
          <div fxLayout="row wrap">
            <mat-divider aria-hidden="true" class="app-pb1"></mat-divider>
            <app-value fxFlex="50" label="ELECTRONIC NOTIFICATIONS"></app-value>
            <br />
            <app-value
              layout="row"
              fxFlex="50"
              label="Email Address"
              value="{{ emailAddress }}"
              [translationNeeded]="false"
            ></app-value>
            <br />
            <app-value
              layout="row"
              fxFlex="50"
              label="Text/SMS"
              [value]="mobileNumber"
              [translationNeeded]="false"
            ></app-value>
            <app-action-link
              class="app-pb1"
              tabindex="-1"
            (click)="
              FeatureLogging(
                'ChangeCommunicationPreferences',
                'Change Communication Preferences',
                'Summary - Your contact information'
              )
            "
              title="Change communication preferences"
              routerLink="../PreferencesPage"
            [queryParams]="{
              focus: 'changepreferences',
              claimId: claimId,
              source: source
            }"
            ></app-action-link>
          </div>
        }
      </div>
    </app-panel>
    `,
    styles: [],
    standalone: false
})
export class ContactPreferencesComponent
  extends BaseComponent
  implements OnInit
{
  @Input()
  claim: SearchResult;
  
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
  
  states: SelectOption[] = States.options;
  contactInformation: any;
  stateVal: string;
  claimId: string = '';
  source: string = '';
  commPreference: UserPreference;
  emailAddress: string;
  mobileNumber: string;
  showNotificationPreference: boolean = false;

  constructor(
    public claimConfigService: ConfigurationService,
    private session: Session,
    private route: ActivatedRoute,
    private accountService: AccountSettingsService,
    private http: Http,
    private translationPipe: TranslationPipe
  ) {
    super();
    this.route.queryParams.subscribe((p) => this.loadClaimFromUrl());
  }

  async ngOnInit() {
    await this.GetCommPreferences();
    this.showNotificationPreference =
      await this.claimConfigService.getConfigFeatureAccess(
        'notificationpreferences'
      );
  }

  private async loadClaimFromUrl() {
    this.session.loadUser();
    this.claimId = this.route.snapshot.queryParamMap.get('claimId');
    this.source = this.route.snapshot.queryParamMap.get('source');
    if (this.claimId) {
      // Pass query params for caching. Claim summary makes same call.
      this.claim = await this.http.get<SearchResult>(
        `/api/claim/${this.source}/${this.claimId}/${'NA'}/summary`,
        {
          queryParams: {
            excludeClaimTracker: false,
            excludeFeatureLog: false,
          },
        }
      );
    }
    if (this.source != 'L') {
      const list = await this.claimConfigService.GetExistingContactPrefernces(
        this.claim
      );
      if (list != undefined) {
        this.contactInformation = list;
        const stateList = this.states;

        for (const lists of stateList) {
          const vals = lists.value;
          const lab = lists.label;
          if (vals == this.contactInformation.state) {
            this.stateVal = lab;
          }
        }
      }
    }
    if (
      this.session.user.emulatorContext &&
      this.session.user.emulatorContext.isEmulating &&
      this.claimConfigService.getFeatureAccess('updatecontactaddress')
    ) {
      this.contactInformation.street1 = hideString(
        this.contactInformation.street1,
        '*'
      );
      this.contactInformation.street2 = hideString(
        this.contactInformation.street2,
        '*'
      );
      this.contactInformation.address = hideString(
        this.contactInformation.address,
        '*'
      );
      this.contactInformation.city = hideString(
        this.contactInformation.city,
        '*'
      );
      this.contactInformation.zipcode = hideString(
        this.contactInformation.zipcode,
        '*'
      );
      this.stateVal = hideString(this.stateVal, '*');
      this.emailAddress = hideString(this.emailAddress, '*');
      this.mobileNumber = hideString(this.mobileNumber, '*');
    }
  }

  async GetCommPreferences() {
    this.commPreference = await this.accountService.getCommPreferences();
    if (this.commPreference) {
      if (this.commPreference?.email && this.commPreference.isEmail == true) {
        this.emailAddress = this.commPreference.email;
      } else {
        this.emailAddress = this.translationPipe.transform('Not enabled', this.translationRequest);
      }
      if (
        this.commPreference?.messagePhone &&
        this.commPreference.isMessage == true
      ) {
        const formatedphone = this.formatPhoneNumber(
          this.commPreference.messagePhone
        );
        this.mobileNumber = formatedphone;
      } else {
        this.mobileNumber = this.translationPipe.transform('Not enabled', this.translationRequest);
      }

      // Following masking is needed if user tries to do hard refresh on the page
      if(
        this.session.user.emulatorContext &&
        this.session.user.emulatorContext.isEmulating
      ) {
        this.emailAddress = hideString(this.emailAddress, '*');
        this.mobileNumber = hideString(this.mobileNumber, '*');
      }
    }
  }

  formatPhoneNumber(phoneNumberString: string): string {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const intlCode = match[1] ? '+1 ' : '';
      return [intlCode, match[2], '-', match[3], '-', match[4]].join('');
    }
    return null;
  }
}
